import { createFeatureSelector } from '@ngrx/store';
import { CHECKIN_PASSENGER_INPUT_STORE_NAME, CheckinPassengerInputState } from './checkin-passenger-input.state';

/** Select CheckinPassengerInput State */
export const selectCheckinPassengerInputState = createFeatureSelector<CheckinPassengerInputState>(
  CHECKIN_PASSENGER_INPUT_STORE_NAME
);
